(function () {
  function initLeggingsFinder(root) {
    if (!root || root.dataset.finderInitialized === "true") return;
    root.dataset.finderInitialized = "true";

    const configNode = root.querySelector("[data-finder-config]");
    const config = configNode ? JSON.parse(configNode.textContent) : {};

    const state = {
      step: 1,
      shape: null,
      feel: null,
      activities: new Set(),
    };

    const panels = Array.from(root.querySelectorAll("[data-finder-step-panel]"));
    const statusNode = root.querySelector("[data-finder-status]");
    const stepLabel = root.querySelector("[data-finder-step-label]");
    const shapeStep = root.querySelector('[data-finder-progress-chip="shape"]');
    const feelStep = root.querySelector('[data-finder-progress-chip="feel"]');
    const activityStep = root.querySelector('[data-finder-progress-chip="activity"]');
    const shapeValue = root.querySelector('[data-finder-progress-value="shape"]');
    const feelValue = root.querySelector('[data-finder-progress-value="feel"]');
    const activityValue = root.querySelector('[data-finder-progress-value="activity"]');
    const optionButtons = Array.from(root.querySelectorAll("[data-finder-option]"));
    const resetButtons = Array.from(root.querySelectorAll("[data-finder-reset]"));
    const nav = root.querySelector("[data-finder-nav]");
    const navResetButton = root.querySelector("[data-finder-reset-nav]");
    const nextButton = root.querySelector("[data-finder-next]");
    const nextButtonLabel = nextButton ? nextButton.querySelector(".leggings-finder__action-label") : null;
    const liveCountNode = root.querySelector("[data-finder-live-count]");
    const stepFeedbackNodes = Array.from(root.querySelectorAll("[data-finder-step-feedback]"));
    const emptyStateNode = root.querySelector("[data-finder-empty-state]");
    const resultsHeader = root.querySelector("[data-finder-results-header]");
    const resultsCountNode = root.querySelector("[data-finder-results-count]");
    const resultsFiltersNode = root.querySelector("[data-finder-results-filters]");
    const resultsGrid = root.querySelector("[data-finder-results-grid]");
    const resultItems = Array.from(root.querySelectorAll("[data-finder-result-item]"));
    const resultIndex = resultItems.map((item, index) => ({
      id: index,
      shape: item.dataset.finderShape || "",
      feel: item.dataset.finderFeel || "",
      activities: new Set((item.dataset.finderActivity || "").split(",").filter(Boolean)),
      element: item,
    }));

    let pendingAdvanceFromStep = null;
    let deferredUiFrame = null;
    const stepThreeCtaDisabledText = "Aktivität auswählen";
    const stepThreeCtaEnabledText = "Matches anzeigen";
    const prefetchedStepImages = new Set();
    const scheduledPrefetchSteps = new Set();
    const matchCountCache = new Map();

    function scheduleIdle(task) {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(task, { timeout: 1200 });
      } else {
        setTimeout(task, 120);
      }
    }

    function prefetchStepImages(stepNumber) {
      const panel = root.querySelector(`[data-finder-step-panel="${stepNumber}"]`);
      if (!panel) return;

      const images = Array.from(panel.querySelectorAll("img.leggings-finder__option-image"));
      images.forEach((img) => {
        const url = img.currentSrc || img.src;
        if (!url || prefetchedStepImages.has(url)) return;
        prefetchedStepImages.add(url);

        const pre = new Image();
        pre.decoding = "async";
        pre.src = url;
        if (pre.decode) pre.decode().catch(() => {});
      });
    }

    function scheduleNextStepPrefetch() {
      const nextStep = state.step + 1;
      if (nextStep < 2 || nextStep > 3) return;
      if (scheduledPrefetchSteps.has(nextStep)) return;
      scheduledPrefetchSteps.add(nextStep);
      scheduleIdle(() => prefetchStepImages(nextStep));
    }

    function hasAnySelection() {
      return Boolean(state.shape) || Boolean(state.feel) || state.activities.size > 0;
    }

    function cloneState() {
      return {
        step: state.step,
        shape: state.shape,
        feel: state.feel,
        activities: new Set(state.activities),
      };
    }

    function formatToken(value) {
      if (!value) return "";
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }

    function getStateKey(testState = state) {
      return [
        testState.shape || "",
        testState.feel || "",
        Array.from(testState.activities).sort().join("|"),
      ].join("::");
    }

    function getActivityProgressValue() {
      if (state.activities.size <= 0) return "";
      if (state.activities.size > 1) return `${state.activities.size} gewählt`;
      return formatToken(Array.from(state.activities)[0]);
    }

    function getActivityFullDisplayValue() {
      if (state.activities.size <= 0) return "";
      return Array.from(state.activities).map(formatToken).join(", ");
    }

    function updateSummary() {
      if (shapeValue) shapeValue.textContent = state.shape ? formatToken(state.shape) : "Auswählen";
      if (feelValue) feelValue.textContent = state.feel ? formatToken(state.feel) : "Auswählen";
      if (activityValue) activityValue.textContent = state.activities.size ? getActivityProgressValue() : "Auswählen";
    }

    function updateResultsSummary() {
      if (!resultsCountNode || !resultsFiltersNode) return;
      const matches = getCurrentMatches().length;
      resultsCountNode.textContent = `${matches} Produkte passend zu deiner Auswahl`;

      const filters = [];
      if (state.shape) filters.push({ label: "Shape", value: formatToken(state.shape) });
      if (state.feel) filters.push({ label: "Tragegefühl", value: formatToken(state.feel) });
      if (state.activities.size) filters.push({ label: "Aktivität", value: getActivityFullDisplayValue() });

      resultsFiltersNode.replaceChildren();
      filters.forEach((item) => {
        const tag = document.createElement("span");
        tag.className = "leggings-finder__result-filter";
        tag.textContent = `${item.label}: ${item.value}`;
        resultsFiltersNode.appendChild(tag);
      });
    }

    function getStickyHeaderOffset() {
      const candidates = [".shopify-section--header", "header[role='banner']", ".header"];
      const header = candidates
        .map((selector) => document.querySelector(selector))
        .find(Boolean);

      if (!header) return 72;

      const rect = header.getBoundingClientRect();
      const stickyVisible = rect.bottom > 0 && rect.top <= 0;
      return stickyVisible ? Math.ceil(rect.height) + 14 : 24;
    }

    function scrollToNode(node) {
      if (!node || isNodeComfortablyVisible(node)) return;
      requestAnimationFrame(() => {
        const offset = getStickyHeaderOffset();
        const top = node.getBoundingClientRect().top + window.scrollY - offset;
        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollTo({
          top: Math.max(0, top),
          behavior: prefersReducedMotion ? "auto" : "smooth",
        });
      });
    }

    function isNodeComfortablyVisible(node) {
      if (!node) return true;
      const offset = getStickyHeaderOffset();
      const rect = node.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const topLimit = offset;
      const bottomLimit = viewportHeight * 0.72;
      return rect.top >= topLimit && rect.top <= bottomLimit;
    }

    function isRecordMatch(record, testState = state) {
      if (testState.shape && record.shape !== testState.shape) return false;
      if (testState.feel && record.feel !== testState.feel) return false;

      if (testState.activities.size > 0) {
        const hasAnyActivity = Array.from(testState.activities).some((selected) => record.activities.has(selected));
        if (!hasAnyActivity) return false;
      }

      return true;
    }

    function getMatchCountByState(testState = state) {
      const key = getStateKey(testState);
      const cached = matchCountCache.get(key);
      if (typeof cached === "number") return cached;

      let count = 0;
      resultIndex.forEach((record) => {
        if (isRecordMatch(record, testState)) count += 1;
      });
      matchCountCache.set(key, count);
      return count;
    }

    function getMatchesByState(testState = state) {
      return resultIndex.filter((record) => isRecordMatch(record, testState));
    }

    function getCurrentMatches() {
      return getMatchesByState(state);
    }

    function updateCount() {
      if (!liveCountNode) return;
      liveCountNode.textContent = String(getMatchCountByState(state));
    }

    function updateResultsView() {
      const matches = getCurrentMatches();
      const matchedIds = new Set(matches.map((record) => record.id));

      resultIndex.forEach((record) => {
        record.element.hidden = !matchedIds.has(record.id);
      });

      if (emptyStateNode) emptyStateNode.hidden = matches.length > 0;
      if (resultsGrid) resultsGrid.hidden = false;
    }

    function getOptionPotentialCount(button) {
      const testState = cloneState();
      const step = button.dataset.step;
      const value = button.dataset.value;

      if (step === "shape") testState.shape = value;
      if (step === "feel") testState.feel = value;
      if (step === "activity") {
        if (testState.activities.has(value)) testState.activities.delete(value);
        else testState.activities.add(value);
      }

      return getMatchCountByState(testState);
    }

    function updateOptionAvailabilityFromMatches(scopeStep = state.step) {
      const baseForActivity = cloneState();
      baseForActivity.activities = new Set();
      const scopedButtons = optionButtons.filter((button) => {
        const type = button.dataset.step;
        if (scopeStep === 1) return type === "shape";
        if (scopeStep === 2) return type === "feel";
        if (scopeStep === 3) return type === "activity";
        return false;
      });

      scopedButtons.forEach((button) => {
        const step = button.dataset.step;
        const value = button.dataset.value;

        if (step === "activity") {
          const selected = state.activities.has(value);
          const testState = cloneState();
          testState.shape = baseForActivity.shape;
          testState.feel = baseForActivity.feel;
          testState.activities = new Set([value]);
          const potentialCount = getMatchCountByState(testState);
          const shouldHide = potentialCount === 0 && !selected;
          button.dataset.finderOptionCount = String(potentialCount);
          button.hidden = shouldHide;
          button.classList.remove("is-disabled");
          button.setAttribute("aria-disabled", "false");
          button.disabled = false;
          return;
        }

        const potentialCount = getOptionPotentialCount(button);
        const selected = step === "shape" ? state.shape === value : state.feel === value;
        const shouldHide = potentialCount === 0 && !selected;
        button.dataset.finderOptionCount = String(potentialCount);
        button.hidden = shouldHide;
        button.classList.remove("is-disabled");
        button.setAttribute("aria-disabled", "false");
        button.disabled = false;
      });
    }

    function updateSelectionsUI() {
      optionButtons.forEach((button) => {
        const step = button.dataset.step;
        const value = button.dataset.value;
        let selected = false;

        if (step === "shape") selected = state.shape === value;
        if (step === "feel") selected = state.feel === value;
        if (step === "activity") selected = state.activities.has(value);

        button.classList.toggle("is-selected", selected);
      });
    }

    function resetOptionUi() {
      optionButtons.forEach((button) => {
        button.classList.remove("is-selected", "is-disabled");
        button.hidden = false;
        button.disabled = false;
        button.setAttribute("aria-disabled", "false");
        button.dataset.finderOptionCount = "";
      });
    }

    function canProceedFromStep(step) {
      const hasMatches = getMatchCountByState(state) > 0;
      if (step === 1) return Boolean(state.shape) && hasMatches;
      if (step === 2) return Boolean(state.feel) && hasMatches;
      if (step === 3) return state.activities.size > 0 && hasMatches;
      return true;
    }

    function updateStepFeedback() {
      stepFeedbackNodes.forEach((node) => {
        const nodeStep = Number(node.dataset.finderStepFeedback);
        if (nodeStep !== state.step || state.step >= 4) {
          node.hidden = true;
          return;
        }

        const hasStepSelection =
          (state.step === 1 && Boolean(state.shape)) ||
          (state.step === 2 && Boolean(state.feel)) ||
          (state.step === 3 && state.activities.size > 0);
        node.hidden = !(hasStepSelection && getMatchCountByState(state) === 0);
      });
    }

    function updatePanelsAndProgress() {
      panels.forEach((panel) => {
        const panelStep = Number(panel.dataset.finderStepPanel);
        const active = panelStep === state.step;
        panel.hidden = !active;
        panel.classList.toggle("is-active", active);
      });

      const current = state.step < 4 ? state.step : 3;
      const chips = [shapeStep, feelStep, activityStep];
      const isResultsStep = state.step === 4;
      chips.forEach((chip, index) => {
        if (!chip) return;
        const stepNumber = index + 1;
        const hasSelection =
          (stepNumber === 1 && Boolean(state.shape)) ||
          (stepNumber === 2 && Boolean(state.feel)) ||
          (stepNumber === 3 && state.activities.size > 0);
        const isActive = !isResultsStep && stepNumber === current;
        const isComplete = hasSelection && (!isActive || isResultsStep);

        chip.classList.toggle("is-active", isActive);
        chip.classList.toggle("is-complete", isComplete);
        chip.classList.toggle("is-pending", !isActive && !isComplete);
      });

      if (stepLabel) {
        stepLabel.textContent = state.step < 4 ? `Schritt ${state.step} von 3` : "Deine Ergebnisse";
      }
    }

    function updateNavigation() {
      let showReset = false;
      let showNext = false;

      if (navResetButton) {
        showReset = hasAnySelection() && state.step < 4;
        navResetButton.hidden = !showReset;
      }

      if (nextButton) {
        if (state.step === 3) {
          nextButton.hidden = false;
          const canProceed = canProceedFromStep(state.step);
          if (nextButtonLabel) nextButtonLabel.textContent = canProceed ? stepThreeCtaEnabledText : stepThreeCtaDisabledText;
          else nextButton.textContent = canProceed ? stepThreeCtaEnabledText : stepThreeCtaDisabledText;
          nextButton.disabled = !canProceed;
          nextButton.classList.toggle("is-ready", canProceed);
          showNext = true;
        } else {
          nextButton.hidden = true;
          nextButton.disabled = true;
          nextButton.classList.remove("is-ready");
        }
      }

      if (nav) nav.hidden = !(showReset || showNext);
    }

    function runImmediateUi() {
      updateSelectionsUI();
      updatePanelsAndProgress();
      updateSummary();
      updateNavigation();
    }

    function runDeferredUi(options = {}) {
      const skipActivityAvailability = options.skipActivityAvailability === true;
      updateCount();
      if (state.step <= 3) {
        if (!(skipActivityAvailability && state.step === 3)) {
          updateOptionAvailabilityFromMatches(state.step);
        }
      }
      updateStepFeedback();
      if (state.step === 4) {
        updateResultsSummary();
        updateResultsView();
      }
    }

    function scheduleDeferredUi(options = {}) {
      if (deferredUiFrame !== null) cancelAnimationFrame(deferredUiFrame);
      deferredUiFrame = requestAnimationFrame(() => {
        runDeferredUi(options);
        deferredUiFrame = null;
      });
    }

    function goToStep(step, options = {}) {
      const shouldScroll = options.scroll === true;
      const previousStep = state.step;
      state.step = Math.max(1, Math.min(4, step));
      if (state.step <= 3) {
        updateOptionAvailabilityFromMatches(state.step);
      }
      runImmediateUi();
      scheduleDeferredUi({ skipActivityAvailability: false });
      scheduleNextStepPrefetch();

      if (shouldScroll && state.step !== previousStep) {
        if (state.step === 4) scrollToNode(resultsHeader || statusNode);
        else scrollToNode(statusNode);
      }
    }

    function autoAdvance(step) {
      if (step >= 3 || pendingAdvanceFromStep === step) return;
      pendingAdvanceFromStep = step;
      requestAnimationFrame(() => {
        goToStep(step + 1, { scroll: true });
        pendingAdvanceFromStep = null;
      });
    }

    function resetFinder() {
      if (deferredUiFrame !== null) {
        cancelAnimationFrame(deferredUiFrame);
        deferredUiFrame = null;
      }
      pendingAdvanceFromStep = null;

      state.step = 1;
      state.shape = null;
      state.feel = null;
      state.activities.clear();
      resetOptionUi();

      resultIndex.forEach((record) => {
        record.element.hidden = true;
      });
      if (emptyStateNode) emptyStateNode.hidden = true;
      if (resultsGrid) resultsGrid.hidden = false;

      updateOptionAvailabilityFromMatches(1);
      runImmediateUi();
      scheduleDeferredUi({ skipActivityAvailability: false });
      scrollToNode(statusNode);
    }

    optionButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const step = button.dataset.step;
        const value = button.dataset.value;
        if (button.hidden || button.disabled || button.classList.contains("is-disabled")) return;

        if (step === "shape") {
          state.shape = value;
          state.feel = null;
        } else if (step === "feel") {
          state.feel = value;
        } else if (step === "activity") {
          if (state.activities.has(value)) state.activities.delete(value);
          else state.activities.add(value);
        }

        runImmediateUi();
        scheduleDeferredUi({ skipActivityAvailability: step === "activity" });

        const activePanelStep = Number(button.closest("[data-finder-step-panel]")?.dataset.finderStepPanel || "0");
        if ((step === "shape" || step === "feel") && state.step === activePanelStep) {
          autoAdvance(state.step);
        }
      });
    });

    if (nextButton) {
      nextButton.addEventListener("click", () => {
        if (!canProceedFromStep(state.step)) return;
        goToStep(state.step + 1, { scroll: true });
      });
    }

    resetButtons.forEach((button) => {
      button.addEventListener("click", resetFinder);
    });

    if (liveCountNode && typeof config.eligibleCount === "number") {
      liveCountNode.textContent = String(config.eligibleCount);
    }

    goToStep(1);
  }

  function initAllLeggingsFinders(scope) {
    const rootNode = scope && scope.querySelectorAll ? scope : document;
    const finders = Array.from(rootNode.querySelectorAll("[data-leggings-finder]"));
    if (rootNode.matches && rootNode.matches("[data-leggings-finder]")) {
      finders.unshift(rootNode);
    }
    finders.forEach((finder) => initLeggingsFinder(finder));
  }

  initAllLeggingsFinders(document);
  document.addEventListener("shopify:section:load", (event) => {
    initAllLeggingsFinders(event.target);
  });
})();
